import {ILoaderParams} from "../../services/loader-service-impl/ILoaderParams";
import {ISearchParam, ISortParam} from "../../definitions";
export enum E_ENDPOINTS {
  API,
  PROFILES,
  LISTS,
  LOGS,
  RECEIPTS,
  HISTORY
}


export class LoaderParams implements ILoaderParams {
  private body: any = {};
  private endpointId: E_ENDPOINTS;


  constructor() {
  }

  setEndpointId(id:E_ENDPOINTS)
  {
    this.endpointId = id;
    return this;
  }


  setEndpointApi() {
    this.endpointId = E_ENDPOINTS.API;
    return this;
  }


  setEndpointProfiles() {
    this.endpointId = E_ENDPOINTS.PROFILES;
    return this;
  }


  createEndpointUrl(s: string): string {
    switch (this.endpointId) {
      case E_ENDPOINTS.API: return `/api/${s}`;
      case E_ENDPOINTS.PROFILES: return `/profiles2/${s}`;
      case E_ENDPOINTS.LOGS: return `/logs/${s}`;
      //case E_ENDPOINTS.LISTS: return `/lists/${s}`;
      case E_ENDPOINTS.RECEIPTS: return `/receipts/${s}`;
      case E_ENDPOINTS.HISTORY: return `/history/${s}`;
    }

    throw new Error(`Unknown endpoint ${this.endpointId}`);
  }


  setAdditionalParam(key:string, value: any): LoaderParams {
    this.body[key] = value;
    return this;
  }


  setObjectType(type: string): LoaderParams {
    this.setAdditionalParam("_type", type);
    return this;
  }


  setNavParams(offset: number = 0, limit: number = 1): LoaderParams {
    this.body.offset = offset;
    this.body.limit = limit;
    return this;
  }


  setSearchParams(search: ISearchParam[] = []): LoaderParams {
    this.body.search = search;
    return this;
  }

  setSortParams(sort:ISortParam[]=[]):LoaderParams{
    let sortObj:any = {};
    for (let i = 0; i < sort.length; i++)
    {
      sortObj[sort[i].property] = sort[i].order;
    }
    this.body.sort = sortObj;
    return this;
  }


  getBody(): any {
    return this.body;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/params/loader-params.ts